<template>
    <div class="form-cols">
        <div class="form-col1">
            <InputForm />
        </div>
        <div class="form-col2">
            <OutputForm />
        </div>
        <div class="form-col3">
            <div class="flex">
                <PaybackForm />
                <Contact />
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { defineAsyncComponent } from 'vue'

const InputForm = defineAsyncComponent(() =>
    import ('@/components/InputForm.vue'))
const OutputForm = defineAsyncComponent(() =>
    import ('@/components/OutputForm.vue'))
const PaybackForm = defineAsyncComponent(() =>
    import ('@/components/PaybackForm.vue'))
const Contact = defineAsyncComponent(() =>
    import ('@/components/Contact.vue'))

export default {
    name: 'Home',
    components: {
        InputForm,
        OutputForm,
        PaybackForm,
        Contact
    },
    data() {
        return {
            show: true
        }
    }
}
</script>